const styles = {
  container: {
    width: "100%",
    textAlign: "center",
    height: "80px",
    overflowY: "visible",
    position: "relative",
  },
  containerOpen: {
    backgroundColor: "#161A24",
  },
  destinationsContainer: {
    backgroundColor: "#161A24",
    overflowX: "hidden",
    overflowY: "scroll",
    height: "100vh",
    "& > button:first-child": {
      marginTop: "70px",
    },
    "@media (max-width: 1200px)": {
      "& > button:first-child": {
        marginTop: "81px",
      },
    },
  },
  searchOptionsContainer: {
    width: "100%",
    paddingTop: 15,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
  },
  stickyPadding: {},
  button: {
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    outline: "none",
    fontFamily: "CircularStd",
    color: "#6373A4",
    "&:focus": {
      outline: "solid rgb(8, 95, 229)",
    },
    "@media (max-width: 1200px)": {
      fontSize: "16px",
    },
  },
  mobileDest: {
    display: "none",
    "@media (max-width: 1199px)": {
      display: "block",
    },
  },
  desktopDest: {
    display: "block",
    "@media (max-width: 1199px)": {
      display: "none",
    },
  },
  tourLabel: {
    background: "#161B24",
    height: "105px",
    paddingBottom: "8px",
    paddingLeft: "52px",
    fontFamily: "CircularStd",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "34px",
    color: "#FDBC48",
    textShadow: "0px 2px 8px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-end",
  },
  personalizationStars: {
    position: "absolute",
    top: "76px",
    left: "22px",
    transform: "scale(1.1)",
  },
  search: {
    border: "none",
    background: "none",
    height: "42px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    filter: "invert(1)",
    transform: "scale(1.1)",
    marginLeft: "auto",
    marginRight: "22px",
    marginBottom: "8px",
  },
  searchWithForYou: {
    position: "absolute",
    top: "76px",
    right: "26px",
    filter: "invert(1)",
    transform: "scale(1.1)",
    height: 0,
    border: "none",
  },
};

export default styles;
